(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtc-collection-products-display"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.classList.add("my-recommendation-html")
        html.innerHTML = text;
        const recommendations = html.querySelector('#similar-products-container');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .then(() => {
        const similarLeftArrow = document.getElementById("similar-products-left-arrow");
  const similarRightArrow = document.getElementById("similar-products-right-arrow");
  const similarWrapper = document.getElementById("similar-products-wrapper");
  const similarContainer = document.getElementById("similar-products-container");
  let similarCards = document.getElementsByClassName("similar-product");

  appendSlidesAfter();

  similarCards = document.getElementsByClassName("similar-product");

  let similarCount = similarCards.length - 1;
  let similarPosition = 4;
  let similarShiftLength = similarCards[0].offsetWidth + 20;

  function appendSlidesAfter() {
    const afterSlides = [];
    const beforeSlides = [];

    for (let i = 0; i <= 3; i++) {
      const slideClone = similarCards[i].cloneNode(true);
      afterSlides.push(slideClone);
    }

    for (let i = similarCards.length - 4; i <= similarCards.length - 1; i ++) {
      const slideCloneBefore = similarCards[i].cloneNode(true);
      beforeSlides.unshift(slideCloneBefore);
    }

    for (let i = 0; i < 4; i++) {
      similarContainer.appendChild(afterSlides[i]);
      similarContainer.insertBefore(beforeSlides[i], similarCards[0]);
    }
  }

  const productShiftLeft = () => {
  similarPosition--;
  similarContainer.style.transition = "transform 0.4s ease-in-out";
  similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;

  if (similarPosition <= 0) {
    const onTransitionEnd = () => {
      similarContainer.removeEventListener('transitionend', onTransitionEnd);
      similarPosition = similarCards.length - 8;
      similarContainer.style.transition = "transform 0s";
      similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;
    };

    similarContainer.addEventListener('transitionend', onTransitionEnd);
  }
};


  const productShiftRight = () => {
    if (similarPosition < similarCount - 3) {
      similarPosition++;
      similarContainer.style.transition = "transform 0.4s ease-in-out";
      similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;
    }
    
    if (similarPosition >= similarCount - 3) {
      const onTransitionEnd = () => {
        similarContainer.removeEventListener('transitionend', onTransitionEnd);
        similarPosition = 4;
        similarContainer.style.transition = "transform 0s";
        similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;
      };

      similarContainer.addEventListener('transitionend', onTransitionEnd);
      
    }    
  }

  const updateSimilarCards = () => {
    similarShiftLength = similarCards[0].offsetWidth + 20;

    similarContainer.style.transition = "transform 0s";
    similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;
  }

  window.addEventListener("resize", () => {
    updateSimilarCards();
  });

  similarLeftArrow.addEventListener("click", () => {
    productShiftLeft();
  });

  similarRightArrow.addEventListener("click", () => {
    productShiftRight();
  });

  updateSimilarCards();
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('#similar-products-container');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 0px 0px'});

  observer.observe(productRecommendationsSection);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-recommendations-testing"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["similar-products-carousel"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.classList.add("my-recommendation-html")
        html.innerHTML = text;
        const recommendations = html.querySelector('#similar-products-container');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .then(() => {
        const similarLeftArrow = document.getElementById("similar-products-left-arrow");
  const similarRightArrow = document.getElementById("similar-products-right-arrow");
  const similarWrapper = document.getElementById("similar-products-wrapper");
  const similarContainer = document.getElementById("similar-products-container");
  let similarCards = document.getElementsByClassName("similar-product");

  appendSlidesAfter();

  similarCards = document.getElementsByClassName("similar-product");

  let similarCount = similarCards.length - 1;
  let similarPosition = 4;
  let similarShiftLength = similarCards[0].offsetWidth + 20;

  function appendSlidesAfter() {
    const afterSlides = [];
    const beforeSlides = [];

    for (let i = 0; i <= 3; i++) {
      const slideClone = similarCards[i].cloneNode(true);
      afterSlides.push(slideClone);
    }

    for (let i = similarCards.length - 4; i <= similarCards.length - 1; i ++) {
      const slideCloneBefore = similarCards[i].cloneNode(true);
      beforeSlides.unshift(slideCloneBefore);
    }

    for (let i = 0; i < 4; i++) {
      similarContainer.appendChild(afterSlides[i]);
      similarContainer.insertBefore(beforeSlides[i], similarCards[0]);
    }
  }

  const productShiftLeft = () => {
  similarPosition--;
  similarContainer.style.transition = "transform 0.4s ease-in-out";
  similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;

  if (similarPosition <= 0) {
    const onTransitionEnd = () => {
      similarContainer.removeEventListener('transitionend', onTransitionEnd);
      similarPosition = similarCards.length - 8;
      similarContainer.style.transition = "transform 0s";
      similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;
    };

    similarContainer.addEventListener('transitionend', onTransitionEnd);
  }
};


  const productShiftRight = () => {
    if (similarPosition < similarCount - 3) {
      similarPosition++;
      similarContainer.style.transition = "transform 0.4s ease-in-out";
      similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;
    }
    
    if (similarPosition >= similarCount - 3) {
      const onTransitionEnd = () => {
        similarContainer.removeEventListener('transitionend', onTransitionEnd);
        similarPosition = 4;
        similarContainer.style.transition = "transform 0s";
        similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;
      };

      similarContainer.addEventListener('transitionend', onTransitionEnd);
      
    }    
  }

  const updateSimilarCards = () => {
    similarShiftLength = similarCards[0].offsetWidth + 20;

    similarContainer.style.transition = "transform 0s";
    similarContainer.style.transform = `translate(-${similarPosition * similarShiftLength}px)`;
  }

  window.addEventListener("resize", () => {
    updateSimilarCards();
  });

  similarLeftArrow.addEventListener("click", () => {
    productShiftLeft();
  });

  similarRightArrow.addEventListener("click", () => {
    productShiftRight();
  });

  updateSimilarCards();
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('#similar-products-container');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 0px 0px'});

  observer.observe(productRecommendationsSection);

  

  } catch(e) { console.error(e); }
})();
})();
